module.exports = __webpack_public_path__ + "static/media/106-panama.15a49ea0.svg";